import { closeEmailSubOrderModal } from '../State/emailSubOrderModal'

export default () => (dispatch) => {

  dispatch(closeEmailSubOrderModal())

}
